import { Flex, Text, Box } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { BXInput, BXButton } from "@/styles";
import { useMemo, useState } from "react";
import { emailValid, passwordValid } from "@/utils/regexp";
import { checkSubAccountEmailApi } from "@/api/subAccount";
import { useNavigate } from "react-router-dom";

const Create = ({
  pwdInput,
  setPwdInput,
  rePwdInput,
  setRePwdInput,
  setCurrStep,
  setEmailInput,
  emailInput,
  ADD_STEP,
}) => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [isInvalidPwd, setIsInvalidPwd] = useState(false);
  const [isExistedEmail, setIsExistedEmail] = useState(false);
  const [isDeletedEmail, setIsDeletedEmail] = useState(false);
  const [isInvalidRePwd, setIsInvalidRePwd] = useState(false);
  const [isInvalidEmail, setIsInvalidEmail] = useState(false);

  const pwdChange = (event) => {
    const pwd = event.target.value;
    setPwdInput(pwd);
    if (pwd) {
      if (passwordValid(pwd)) {
        setIsInvalidPwd(false);
      } else {
        setIsInvalidPwd(true);
      }
    } else {
      setIsInvalidPwd(false);
    }
  };

  const emailBlur = (event) => {
    const email = event.target.value;
    setEmailInput(email);
    if (email) {
      if (emailValid(email)) {
        setIsInvalidEmail(false);
      } else {
        setIsInvalidEmail(true);
      }
    } else {
      setIsInvalidEmail(false);
      setIsDeletedEmail(false);
      setIsExistedEmail(false);
    }
  };

  const rePwdChange = (event) => {
    const rePwd = event.target.value;
    setRePwdInput(rePwd);
    if (rePwd) {
      if (rePwd === pwdInput) {
        setIsInvalidRePwd(false);
      } else {
        setIsInvalidRePwd(true);
      }
    } else {
      setIsInvalidRePwd(false);
    }
  };

  const canSubmit = useMemo(() => {
    if (
      rePwdInput &&
      pwdInput &&
      emailInput &&
      !isInvalidEmail &&
      !isInvalidPwd &&
      !isInvalidRePwd
    ) {
      return true;
    }
    return false;
  }, [
    pwdInput,
    rePwdInput,
    emailInput,
    isInvalidEmail,
    isInvalidPwd,
    isInvalidRePwd,
  ]);

  const checkSubAccountEmailFunc = async () => {
    if (!emailInput) return;
    if (canSubmit) {
      const res = await checkSubAccountEmailApi({ email: emailInput });
      if (res.code === 0) {
        const { is_deleted, is_exist } = res.data;
        if (is_deleted) {
          setIsDeletedEmail(true);
          return;
        }
        if (is_exist) {
          setIsExistedEmail(true);
          return;
        }
        setCurrStep(ADD_STEP.VERIFY);
      }
    }
  };

  const memoEmailError = useMemo(() => {
    if (isDeletedEmail || isInvalidEmail || isExistedEmail) {
      return true;
    }
    return false;
  }, [isInvalidEmail, isExistedEmail, isDeletedEmail]);

  return (
    <Flex
      alignItems={"center"}
      flexDirection={"column"}
      w={["90%", "500px"]}
      justifyContent={"flex-start"}
      margin={"0 auto"}
    >
      <Text fontSize={"24px"} fontWeight={600}>
        {t("kdGDbDfHqPdMmOODj")}
      </Text>
      <Box mt="40px" w={"100%"}>
        <Text fontSize={"14px"}>{t("TVTktEvtpSXRbnxIB")}</Text>
        <BXInput
          placeholder={t("leXQdnNvhrYWetVTXjE")}
          mt="10px"
          onBlur={emailBlur}
          value={emailInput}
          onChange={(e) => setEmailInput(e.target.value)}
          className={memoEmailError ? "error" : ""}
        />
        {isInvalidEmail && (
          <Text color="red.100" fontSize="12px" mt="5px">
            {t("PIxkcsUxBzUPVVFfu")}
          </Text>
        )}
        {isDeletedEmail && (
          <Text color="red.100" fontSize="12px" mt="5px">
            {t("QHhdRUWMTaGpDwrC")}
          </Text>
        )}
        {isExistedEmail && (
          <Text color="red.100" fontSize="12px" mt="5px">
            {t("sydmFvhfSgzJVhtAud")}
          </Text>
        )}
      </Box>
      <Box mt="30px" w={"100%"}>
        <Text fontSize={"14px"}>{t("txfROteTwdaWdTnlkif")}</Text>
        <BXInput
          placeholder={t("KbSjSRobgQmXjHChGKJ")}
          mt="10px"
          type="password"
          className={isInvalidPwd ? "error" : ""}
          onBlur={pwdChange}
          value={pwdInput}
          onChange={(e) => setPwdInput(e.target.value)}
        />
        {isInvalidPwd && (
          <Text color="red.100" fontSize="12px" mt="5px">
            {t("SMEPVJNtMGWMrEceo")}
          </Text>
        )}
      </Box>
      <Box mt="30px" w={"100%"}>
        <Text fontSize={"14px"}>{t("TAFoyaQLwVzluFioqh")}</Text>
        <BXInput
          placeholder={t("eChfcikkuQFNcZULZuP")}
          mt="10px"
          type="password"
          className={isInvalidRePwd ? "error" : ""}
          onBlur={rePwdChange}
          value={rePwdInput}
          onChange={(e) => setRePwdInput(e.target.value)}
        />
        {isInvalidRePwd && (
          <Text color="red.100" fontSize="12px" mt="5px">
            {t("jgXHbpNLgJMKuuZER")}
          </Text>
        )}
      </Box>
      <Flex mt={"30px"} w={"80%"}>
        <BXButton
          className="cancel"
          w={"30%"}
          onClick={() => navigate("/trade/subAccount")}
        >
          {t("UNForxvjDLCZdGrmWkX")}
        </BXButton>
        <BXButton
          ml={"10px"}
          w={"70%"}
          className={canSubmit ? "" : "disabled"}
          onClick={() => {
            if (canSubmit) {
              checkSubAccountEmailFunc();
            }
          }}
        >
          {t("tOaRBVUJHpnSgDBrGON")}
        </BXButton>
      </Flex>
    </Flex>
  );
};

export default Create;
